import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import PageHeader from "../shared/PageHeader";
import shopApi from "../../api/shop";
import theme from "../../data/theme";
import { saveUserConnected } from "../../store/user/userActions";
import { withRouter } from "react-router-dom";

function AccountPageLogin({ history }) {
    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [registerConfirm, setRegisterConfirm] = useState("");
    const [registerFirstName, setRegisterFirstName] = useState("");
    const [registerLastName, setRegisterLastName] = useState("");
    const [registerPhone, setRegisterPhone] = useState("");
    const [errors, setErrors] = useState({});

    const dispatch = useDispatch();

    const validate = () => {
        const newErrors = {};

        if (!registerFirstName.trim()) newErrors.firstName = "First name is required.";
        if (!registerLastName.trim()) newErrors.lastName = "Last name is required.";
        if (!registerPhone.trim()) newErrors.phone = "Phone number is required.";
        if (!registerEmail.trim()) {
            newErrors.email = "Email address is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(registerEmail)) {
            newErrors.email = "Invalid email address.";
        }
        if (!registerPassword) {
            newErrors.password = "Password is required.";
        } else if (registerPassword.length < 6) {
            newErrors.password = "Password must be at least 6 characters.";
        }
        if (registerPassword !== registerConfirm) {
            newErrors.confirm = "Passwords do not match.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleRegisterSubmit = async (event) => {
        event.preventDefault();
        if (!validate()) return;

        try {
            const response = await shopApi.register({
                email: registerEmail,
                password: registerPassword,
                firstName: registerFirstName,
                lastName: registerLastName,
                phone: registerPhone,
            });
            if (response) {
                dispatch(saveUserConnected(response));
                history.push("/");
            }
        } catch (error) {
            console.error("Registration failed", error);
        }
    };

    const breadcrumb = [
        { title: <FormattedMessage id="header.home" defaultMessage="Home" />, url: "" },
        { title: <FormattedMessage id="header.myAccount" defaultMessage="My Account" />, url: "" },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Login — ${theme.name}`}</title>
            </Helmet>

            <PageHeader header={<FormattedMessage id="header.myAccount" defaultMessage="My Account" />} breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="mt-4 mt-md-0">
                        <div className="card flex-grow-1 mb-0">
                            <div className="card-body">
                                <h3 className="card-title">Register</h3>
                                <form onSubmit={handleRegisterSubmit} noValidate>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="register-first-name"><FormattedMessage id="Account.firstName" defaultMessage="First name" /></label>
                                            <input
                                                id="register-first-name"
                                                type="text"
                                                className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                                                placeholder="Enter your first name"
                                                value={registerFirstName}
                                                onChange={(e) => setRegisterFirstName(e.target.value)}
                                            />
                                            {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="register-last-name"><FormattedMessage id="Account.lastName" defaultMessage="Last name" /></label>
                                            <input
                                                id="register-last-name"
                                                type="text"
                                                className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                                                placeholder="Enter your last name"
                                                value={registerLastName}
                                                onChange={(e) => setRegisterLastName(e.target.value)}
                                            />
                                            {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="register-phone"><FormattedMessage id="Account.phone" defaultMessage="Phone" /></label>
                                            <input
                                                id="register-phone"
                                                type="text"
                                                className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                                placeholder="Enter your phone number"
                                                value={registerPhone}
                                                onChange={(e) => setRegisterPhone(e.target.value)}
                                            />
                                            {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="register-email"><FormattedMessage id="Account.email" defaultMessage="Email" /></label>
                                            <input
                                                id="register-email"
                                                type="email"
                                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                                placeholder="Enter email"
                                                value={registerEmail}
                                                onChange={(e) => setRegisterEmail(e.target.value)}
                                            />
                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="register-password"><FormattedMessage id="Account.password" defaultMessage="Password" /></label>
                                        <input
                                            id="register-password"
                                            type="password"
                                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                            placeholder="Password"
                                            value={registerPassword}
                                            onChange={(e) => setRegisterPassword(e.target.value)}
                                        />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="register-confirm"><FormattedMessage id="Account.confirmPassword" defaultMessage="Confirm Password" /></label>
                                        <input
                                            id="register-confirm"
                                            type="password"
                                            className={`form-control ${errors.confirm ? "is-invalid" : ""}`}
                                            placeholder="Repeat Password"
                                            value={registerConfirm}
                                            onChange={(e) => setRegisterConfirm(e.target.value)}
                                        />
                                        {errors.confirm && <div className="invalid-feedback">{errors.confirm}</div>}
                                    </div>
                                    <button type="submit" className="btn btn-primary mt-2 mt-md-3 mt-lg-4">
                                        Register
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(AccountPageLogin);
